import { pharmaciesMap } from "../store/PharmaciesMap.js";

export function pharmaciesSearch(selectorOrDomElement) {
    let $pharmaciesBlock = $(selectorOrDomElement);
    let $pharmacySearchInput = $pharmaciesBlock.find('.js-pharmacy-search-input');
    let pharmacySearchBtnClass = '.js-pharmacy-search-btn';

    let $pharmaciesList = $('.js-pharmacies-list', $pharmaciesBlock);
    let $pharmaciesMapList = $('.js-pharmacies-map-list', $pharmaciesBlock);

    $pharmaciesBlock.data('rendered', true);

    $pharmacySearchInput.on('input blur init', function(e) {
        let val = $.trim($(this).val());
        let $searchWrap = $(this).closest('.js-input-wrap');

        if (!val.length) {
            $searchWrap.removeClass('_filled');
        } else {
            $searchWrap.addClass('_filled');
        }

        if (e.type == 'blur') {
            $searchWrap.removeClass('_focused');
        }
    })
    .on('focus', function() {
        $(this).closest('.js-input-wrap').addClass('_focused');
    })
    .trigger('init');

    $pharmaciesBlock.on('click', pharmacySearchBtnClass, function(e) {
        e.preventDefault();
        pharmaciesSearchAjax($(this), $pharmacySearchInput.val());
    });

    $pharmaciesBlock.on('keydown', ('.js-pharmacy-search-input'), function(e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            pharmaciesSearchAjax($(this), $pharmacySearchInput.val());
        }
    });

    // сброс поискового фильтра
    $pharmaciesBlock.on('click', '.js-pharmacy-search-reset', function(e) {
        e.preventDefault();

        pharmaciesSearchAjax($(this), '', true);
    });

    function pharmaciesSearchAjax($btn, query, isClear) {
        $pharmaciesBlock = $btn.closest('.js-pharmacy-choice');
        $pharmacySearchInput = $pharmaciesBlock.find('.js-pharmacy-search-input');

        if (isClear) {
            $pharmacySearchInput.val('');
        }

        $pharmaciesBlock.trigger('pharmaciesSearch:before');

        $.ajax({
            url: $pharmaciesBlock.data('url'),
            method: $pharmaciesBlock.data('method') || 'GET',
            data: {
                'search': query,
                'clearSearch' : !!isClear
            },
            success: (response) => {
                $pharmaciesList.html(response.list);
                pharmaciesMap(response.map);

                // if (query.length === 0) {
                //     $pharmacySearchInput.val('').closest('.js-input-wrap').removeClass('_filled');
                // }
            },
            error: () => {
                console.log('Ошибка получения данных');
            },
            complete: () => {
                $pharmaciesBlock.trigger('pharmaciesSearch:complete');
            }
        });
    }
}

App.D.ready(pharmaciesSearch('.js-pharmacy-choice'));
